import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import MonthlyTimeIcon from "@iconify/icons-mdi/view-module-outline";
import WeeklyTimeIcon from "@iconify/icons-mdi/view-stream-outline";
import { InlineIcon } from "@iconify/react";
import { PeriodType } from "my-timesheet/types/period-type";

interface MyRequestsDashboardDateRangePeriodIconsProps {
  isMobile: boolean;
  iconSize: number;
  period: string;
  onPeriodChange: (period: PeriodType) => void;
}

export const MyTimesheetMyRequestsDashboardDateRangePeriodIcons = ({
  isMobile,
  iconSize,
  period,
  onPeriodChange,
}: MyRequestsDashboardDateRangePeriodIconsProps) => {
  const theme = useTheme();
  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      mb={isMobile ? 1 : 0}
      mr={isMobile ? 0 : 3}
    >
      <InlineIcon
        id="month"
        icon={MonthlyTimeIcon}
        width={iconSize}
        height={iconSize}
        onClick={() => onPeriodChange("month")}
        color={period === "month" ? "#cc0033" : theme.palette.gray60.main}
        style={{ cursor: "pointer" }}
      />
      <Box width="10px" />
      <InlineIcon
        id="week"
        icon={WeeklyTimeIcon}
        width={iconSize}
        height={iconSize}
        onClick={() => onPeriodChange("week")}
        color={period === "week" ? "#cc0033" : theme.palette.gray60.main}
        style={{ cursor: "pointer" }}
      />
    </Box>
  );
};

export default MyTimesheetMyRequestsDashboardDateRangePeriodIcons;
